/** Standard display order: Street name/No, Postcode, Region, Country */

export type StandardAddressParts = {
  street?: string | null
  zip?: string | null
  postcode?: string | null
  state?: string | null
  region?: string | null
  country?: string | null
  city?: string | null
}

export const STANDARD_ADDRESS_PLACEHOLDER = 'Street name/No, Postcode, Region, Country'

export function formatStandardAddress(parts: StandardAddressParts): string {
  const postcode = (parts.postcode ?? parts.zip ?? '').trim()
  const region = (parts.region ?? parts.state ?? '').trim()
  return [parts.street, postcode, region, parts.country]
    .map((s) => (s == null ? '' : String(s).trim()))
    .filter(Boolean)
    .join(', ')
}
